import { Component, OnInit, ViewChild } from '@angular/core';
import { PopupModel, PopupButton, PopupModelReturn, SP_Type, SPType_ServiceProvider, ServiceProvider, PopupSetupModel } from '../../AllTableClasses';
import { PopupNotificationService } from '../../Services/popup-notification.service';
import { Router } from '@angular/router';
import { NotificationPopupComponent } from '../Components/notification-popup/notification-popup.component';
import { ServiceProviderService } from '../../Services/service-provider.service';
import { LoadingService } from '../../Services/loading.service';
import { ReportsService } from '../../Services/reports.service';

@Component({
  selector: 'app-service-main-page',
  templateUrl: './service-main-page.component.html',
  styleUrl: './service-main-page.component.scss'
})
export class ServiceMainPageComponent implements OnInit{

  @ViewChild('popup') popup!: NotificationPopupComponent;
  @ViewChild('servicePopup') ServicePopup!: NotificationPopupComponent;

  public SP_Types: Array<SP_Type> = new Array<SP_Type>();

  public TestingServices: SPType_ServiceProvider = new SPType_ServiceProvider();
  public OtherServices: SPType_ServiceProvider = new SPType_ServiceProvider();
  public FittingServices: SPType_ServiceProvider = new SPType_ServiceProvider();
  public SpecialServices: SPType_ServiceProvider = new SPType_ServiceProvider();
  public AdminSpecialServices: SPType_ServiceProvider = new SPType_ServiceProvider();

  public SP_ServiceProviders: Array<SPType_ServiceProvider> = new Array<SPType_ServiceProvider>();

  public selectedService: ServiceProvider = new ServiceProvider();
  public pagedTestingServices: Array<ServiceProvider> = new Array<ServiceProvider>();
  public pagedOtherServices: Array<ServiceProvider> = new Array<ServiceProvider>();
  public pagedFittingServices: Array<ServiceProvider> = new Array<ServiceProvider>();
  public pagedSpecialServices: Array<ServiceProvider> = new Array<ServiceProvider>();
  public pagedAdminSpecialServices: Array<ServiceProvider> = new Array<ServiceProvider>();
  public report: string = '';

  constructor(
    private router: Router,
    private popupNotificationService: PopupNotificationService,
    private serviceProviderService: ServiceProviderService,
    private reportService: ReportsService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.SPTypeServiceProviderGet();
  }

  
  public selectService(service: ServiceProvider)
  {
    if (!service.Selected)
    {
      this.selectedService = new ServiceProvider();
    } else
    {
      if (this.selectedService && this.selectedService.Guid !== service.Guid)
      {
        this.selectedService.Selected = false;
      }
      this.selectedService = service;
    }
  }

  public SPTypeServiceProviderGet() {
    this.selectedService = new ServiceProvider();

    this.serviceProviderService.SPTypeServiceProviderGet((data) => {
      if (data.Success) {
        this.SP_ServiceProviders = data.Data;
        
        this.TestingServices = this.SP_ServiceProviders.filter(s => s.SPType == "Testing")[0];
        this.TestingServices.Services = JSON.parse(data.Data.filter((service: { SPType: string; }) => service.SPType == "Testing")[0].Services);
        this.pagedTestingServices = this.TestingServices.Services;

        this.OtherServices = this.SP_ServiceProviders.filter(s => s.SPType == "Other Services")[0];
        this.OtherServices.Services = JSON.parse(data.Data.filter((service: { SPType: string; }) => service.SPType == "Other Services")[0].Services);
        this.pagedOtherServices = this.OtherServices.Services;

        this.FittingServices = this.SP_ServiceProviders.filter(s => s.SPType == "Fitting")[0];
        this.FittingServices.Services = JSON.parse(data.Data.filter((service: { SPType: string; }) => service.SPType == "Fitting")[0].Services);
        this.pagedFittingServices = this.FittingServices.Services;

        this.SpecialServices = this.SP_ServiceProviders.filter(s => s.SPType == "Special Services")[0];
        this.SpecialServices.Services = JSON.parse(data.Data.filter((service: { SPType: string; }) => service.SPType == "Special Services")[0].Services);
        this.pagedSpecialServices = this.SpecialServices.Services;

        this.AdminSpecialServices = this.SP_ServiceProviders.filter(s => s.SPType == "ABR/VNG ADMIN")[0];
        this.AdminSpecialServices.Services = JSON.parse(data.Data.filter((service: { SPType: string; }) => service.SPType == "ABR/VNG ADMIN")[0].Services);
        this.pagedAdminSpecialServices = this.AdminSpecialServices.Services;

      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  paginateTestingServices(pageItems: Array<ServiceProvider>): void {
    this.pagedTestingServices = [...pageItems];
  }
  paginateOtherServices(pageItems: Array<ServiceProvider>): void {
    this.pagedOtherServices = [...pageItems];
  }
  paginateFittingServices(pageItems: Array<ServiceProvider>): void {
    this.pagedFittingServices = [...pageItems];
  }
  paginateSpecialServices(pageItems: Array<ServiceProvider>): void {
    this.pagedSpecialServices = [...pageItems];
  }
  paginateAdminSpecialServices(pageItems: Array<ServiceProvider>): void {
    this.pagedAdminSpecialServices = [...pageItems];
  }

  public View(service: ServiceProvider) {
    let service_Popup: PopupSetupModel = new PopupSetupModel();
    service_Popup.Title = 'Service Overview';
    service_Popup.PopupAction = 'View';
    service_Popup.Data = service;
    service_Popup.Button = new PopupButton('Back', 'Cancel');

    this.popupNotificationService.ShowServicePopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Cancel') {
      }
      else
      {
      }
    });
  }

  public Edit(service: ServiceProvider) {
    let service_Popup: PopupSetupModel = new PopupSetupModel();
    service_Popup.Title = 'Edit Service';
    service_Popup.PopupAction = 'Edit';
    service_Popup.Data = service;
    service_Popup.Button = new PopupButton('Save', 'Save');

    this.popupNotificationService.ShowServicePopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.ServiceProviderSet(res.Data);
      }
      else
      {
      }
    });
  }

  public Delete(service: ServiceProvider) {
    let newService: ServiceProvider = new ServiceProvider();
    let service_Popup: PopupModel = new PopupModel();
    service_Popup.Message = 'Are you sure you want to delete this service?';
    service_Popup.MessageType = 'error';
    service_Popup.Data = service;
    service_Popup.Button = new PopupButton('Delete', 'Delete');
    service_Popup.AltButton = new PopupButton('Cancel', 'Cancel');


    this.popupNotificationService.ShowPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Delete') {
        service.Active = false;
        this.ServiceProviderSet(service);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public Add() {
    let newService: ServiceProvider = new ServiceProvider();
    let service_Popup: PopupSetupModel = new PopupSetupModel();
    service_Popup.Title = 'New Service';
    service_Popup.PopupAction = 'New';
    service_Popup.Data = newService;
    service_Popup.Button = new PopupButton('Save', 'Save');

    this.popupNotificationService.ShowServicePopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.ServiceProviderSet(res.Data);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }



  public ServiceProviderSet(service: ServiceProvider)
  {
    let service_Popup: PopupModel = new PopupModel();
    service_Popup.Message = 'Service Created';
    service_Popup.MessageType = 'success';
    service_Popup.Button = new PopupButton('Calendar', 'routeToCalendar');

    this.serviceProviderService.ServiceProviderSet(service, (data) => {
      if (data.Success) {

        this.popupNotificationService.ShowPopup(service_Popup).then((res: PopupModelReturn) => {
          if (res.Result === 'routeToServices') {
            this.router.navigate(['scheduler']);
            return;
          }
          else {
            this.SPTypeServiceProviderGet();
          }
        });

      }
      else {
        service_Popup.Message = `${data.UserErrorMessage}`;
        service_Popup.MessageType = 'error';
        this.popupNotificationService.ShowPopup(service_Popup).then((res: PopupModelReturn) => { });
      }
    }, (error) => { });
  }

  onGenerateReport(rendertype: string) {
    const reportPath = 'ServicesReport.rdl';
    const reportName = 'List of Services';

    const parameters = {
      SPTypeGuid: this.report
    }; // Add any required parameters here

    this.loadingService.show();

    this.reportService.GenerateReport(reportPath, reportName, parameters, rendertype, (data: any) => {
      this.loadingService.hide();
      if (data instanceof Blob) {
        if (rendertype == 'PDF') {
          const blob = new Blob([data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${reportName}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          const blob = new Blob([data], { type: "application/vnd.ms-excel" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${reportName}.xls`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      } else if (data.Success === false) {
        // If there's an error, display the error message
        this.loadingService.hide();
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public showNotifcationPopup(success: boolean, message?: string) {
    let notificationPopup: PopupModel = new PopupModel();

    if (success == true) {
    }
    else {
      notificationPopup.Message = message;
      notificationPopup.MessageType = 'error';
      this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => { });
    }

  }
  
}
